import React from 'react';
import i18n from "../../../i18n";
import * as rk from "../../../localization/resourceKeys";
import RighttoCorrectForm from "../../../media/RighttoCorrectForm.pdf";

const VCIB2B = () => {

    return (
      <div className="o-layout u-m-none right-to-correct-wrapper">
        <div className="o-layout__item welcome-note u-mb-none">
          <div>{i18n.t(rk.DATA_CORRECTION.VCI.REPRESENTATIVE)}</div>
        </div>
        <div className="o-layout__item u-mt-small">
          <div className="u-1/1 center-div u-mb-small u-mt">
            <a className="request-form-link" href={RighttoCorrectForm} download="RighttoCorrectForm">
              <button
                id="download-request-btn"
                className="c-btn u-mv-none"
                disabled={false}
              >
                <span className="c-btn__text">
                  {i18n.t(rk.DATA_CORRECTION.VCI.EMPLOYEE_OR_REP_CTA)}
                </span>
              </button>
            </a>
          </div>
        </div>
        <div className="o-layout__item u-mt u-mb-large">
          <p className="u-font-size-fs0">
            {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_1)}
          </p>
          <span>
            <p className="u-mb-none intructions-title u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_2)}
            </p>
            <p className="u-mb-none u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_3)}
            </p>
            <p className="u-mb-none u-font-size-fs0">
              {i18n.t(rk.DATA_CORRECTION.VCI.CURRENT_CUSTOMER_TEXT_4)}
            </p>
          </span>
        </div>
      </div>
    );
}

export default VCIB2B;